// extracted by mini-css-extract-plugin
export default {"breadCrumb":"localizedBreadCrumb-module--breadCrumb--sCSUw","breadCrumbText":"localizedBreadCrumb-module--breadCrumbText--DlNYn","link":"localizedBreadCrumb-module--link--Sd2Jh"};